import React from "react";

const services = [
  {
    title: "Mobile App Development",
    desc: "High-performance Android and iOS apps built for speed, security, and seamless user experience.",
    icon: "📱",
  },
  {
    title: "Web Development",
    desc: "Fast, secure, and scalable websites built with modern technologies for long-term growth.",
    icon: "💻",
  },
  {
    title: "UI/UX Design",
    desc: "Clean, user-focused designs that improve usability, engagement, and conversions.",
    icon: "🎨",
  },
  {
    title: "Digital Marketing",
    desc: "Result-driven SEO and marketing strategies to boost traffic, visibility, and revenue.",
    icon: "📈",
  },
  {
    title: "E-Commerce Services",
    desc: "Complete online store solutions to help your business sell and scale globally.",
    icon: "🛒",
  },
  {
    title: "Brand Strategy",
    desc: "Strong brand positioning and identity development that builds trust and authority.",
    icon: "🏷️",
  },
];

const Services = () => {
  return (
    <section className="bg-gradient-to-br from-gray-50 via-white to-blue-50 py-20 px-6">
      
      {/* Heading */}
      <div className="text-center max-w-3xl mx-auto mb-14">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
          Professional Digital Services
        </h2>
        <p className="mt-4 text-gray-600 text-sm md:text-base leading-relaxed">
          We provide complete digital solutions including mobile app development,
          web development, UI/UX design, digital marketing, e-commerce management,
          and brand strategy to help your business grow globally.
        </p>
      </div>

      {/* Services Grid */}
      <div className="max-w-5xl mx-auto grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((service, index) => (
          <div
            key={index}
            className="relative group bg-white p-8 rounded-2xl shadow-md hover:shadow-2xl hover:-translate-y-3 transition-all duration-500 border border-transparent"
          >
            {/* Hover Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 group-hover:opacity-10 transition duration-500 pointer-events-none rounded-2xl"></div>

            {/* Content Wrapper */}
            <div className="relative z-10">
              
              {/* Icon */}
              <div className="flex justify-center text-4xl mb-4 group-hover:scale-110 transition-transform duration-300">
                {service.icon}
              </div>

              {/* Title */}
              <h3 className="text-center text-xl font-semibold text-gray-900 mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-center text-gray-600 text-sm leading-relaxed">
                {service.desc}
              </p>

              {/* Bottom Line Animation */}
              <div className="mt-6 h-1 w-0 bg-blue-600 group-hover:w-full transition-all duration-300 rounded-full"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;